import { computeRois } from './computeRois';
export const RoiKind = {
    BLACK: 'black',
    WHITE: 'white',
    BW: 'bw',
};
/**
 * Return an array of ROIs matching the options.
 * @param roiMapManager - The ROI map manager containing the ROIs.
 * @param options - Get ROIs options.
 * @returns The array of ROIs.
 */
export function getRois(roiMapManager, options = {}) {
    const { minSurface = 0, maxSurface = Number.MAX_SAFE_INTEGER, kind = 'white', } = options;
    if (roiMapManager.blackRois.length === 0 &&
        roiMapManager.whiteRois.length === 0) {
        computeRois(roiMapManager);
    }
    let rois;
    switch (kind) {
        case 'black': {
            rois = roiMapManager.blackRois;
            break;
        }
        case 'white': {
            rois = roiMapManager.whiteRois;
            break;
        }
        case 'bw': {
            rois = [...roiMapManager.whiteRois, ...roiMapManager.blackRois];
            break;
        }
        default: {
            throw new RangeError(`invalid ROI kind: ${kind}`);
        }
    }
    return rois.filter((roi) => roi.surface >= minSurface && roi.surface <= maxSurface);
}
//# sourceMappingURL=getRois.js.map